import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
  Divider,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  People as PeopleIcon,
  PhotoCamera as PhotoIcon,
  Storage as StorageIcon,
  Dashboard as DashboardIcon,
  LocalFlorist as PlantIcon,
  LocationOn as LocationIcon,
} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    padding: theme.spacing(2),
  },
  listItem: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      cursor: 'pointer',
    },
  },
  active: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    '& .MuiListItemIcon-root': {
      color: theme.palette.primary.contrastText,
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
}));

const AdminMenu = ({ currentPath }) => {
  const classes = useStyles();
  const history = useHistory();

  const menuItems = [
    {
      title: 'Admin Dashboard',
      path: '/admin/crews',
      icon: <DashboardIcon />,
      description: 'Overview and crew management',
    },
    {
      title: 'GPS Archive Manager',
      path: '/admin/gps-archive',
      icon: <StorageIcon />,
      description: 'Manage GPS activity data storage',
    },
    {
      title: 'Photo Notifications',
      path: '/admin/photo-notifications',
      icon: <PhotoIcon />,
      description: 'Manage photo notification system',
    },
    {
      title: 'Dead Plant Tracking',
      path: '/admin-dead-plants-dashboard',
      icon: <PlantIcon />,
      description: 'Track and manage dead plants',
    },
    {
      title: 'Tracked Locations',
      path: '/admin/tracked-locations',
      icon: <LocationIcon />,
      description: 'Manage gas stations and convenience stores',
    },
  ];

  const handleNavigate = (path) => {
    history.push(path);
  };

  return (
    <Paper className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        Admin Functions
      </Typography>
      <Divider />
      <List component="nav">
        {menuItems.map((item) => (
          <ListItem
            key={item.path}
            button
            onClick={() => handleNavigate(item.path)}
            className={`${classes.listItem} ${
              currentPath === item.path ? classes.active : ''
            }`}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText
              primary={item.title}
              secondary={item.description}
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default AdminMenu;